import axios from "axios";
import { API_URL } from "../../config";
import { getToken } from "../../utils/authManager";

export function _fetchPlaylist(params) {
  return new Promise((resolve, reject) => {
    let u = new URLSearchParams(params).toString();
    axios
    .get(`${API_URL}playlist?${u}`, {
      headers: {
        Authorization: getToken(),
      },
    })
    .then(async (response) => {
      resolve(response.data);
    })
    .catch((err) => {
      reject(err);
    });
  });
}

export function _createPlaylist(data) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${API_URL}playlist/create`, data, {
        headers: {
          Authorization: getToken(),
        },
      })
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
export function _fetchOwnPlaylist() {
  return new Promise((resolve, reject) => {
    axios
    .get(`${API_URL}playlist/own`, {
      headers: {
        Authorization: getToken(),
      },
    })
    .then(async (response) => {
      resolve(response.data);
    })
    .catch((err) => {
      reject(err);
    });
  });
}
export function _fetchFollowingPlaylist() {
  return new Promise((resolve, reject) => {
    axios
    .get(`${API_URL}playlist/following`, {
      headers: {
        Authorization: getToken(),
      },
    })
    .then(async (response) => {
      resolve(response.data);
    })
    .catch((err) => {
      reject(err);
    });
  });
}
export function _createSession(data) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${API_URL}session`, data, {
        headers: {
          Authorization: getToken(),
        },
      })
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
export function _getSession(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${API_URL}session/${id}`, {
        headers: {
          Authorization: getToken(),
        },
      })
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
export function _getSessionByUserId() {
  return new Promise((resolve, reject) => {
    axios
      .get(`${API_URL}session/`, {
        headers: {
          Authorization: getToken(),
        },
      })
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
export function _search(data) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${API_URL}user/search/${data}`)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
export function _enroleCourse(data) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${API_URL}course`, data, {
        headers: {
          Authorization: getToken(),
        },
      })
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
export function _getEnroledCourse() {
  return new Promise((resolve, reject) => {
    axios
      .get(`${API_URL}course`,{
        headers: {
          Authorization: getToken(),
        },
      })
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}